import { FC } from 'react';

import { useCityBookingOpportunitiesQuery } from '@queries/PromoterQueries';

import { useAnalytics } from '@hooks/useAnalytics';
import { CurrentCity } from '@hooks/useCurrentUserLocation';

import { useNavigate } from '@router/index';

import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';
import { Skeleton } from '@components/layout/Skeleton/Skeleton';

import stageIconUrl from '../assets/stage.svg';

export const OpenStageSection: FC<{ city?: CurrentCity; back: string }> = ({ city, back }) => {
  const { track } = useAnalytics();
  const navigate = useNavigate();

  const { bookingOpportunitiesAreReady, bookingOpportunities } = useCityBookingOpportunitiesQuery(
    city?._id,
  );

  const openStageIconSize = 48;
  const openStageCount = bookingOpportunities?.filter(({ type }) => type === 'openStage')?.length;
  const handleClickOpenStages = () => {
    track('Click Open Stages');
    navigate(`/noauth/gigs-and-talent/${city?._id}`, {
      state: { back },
    });
  };

  if (!bookingOpportunitiesAreReady) {
    return <Skeleton height={64} />;
  }

  return (
    <div
      className="d-flex align-items-center gap-3 p-2"
      style={{ background: 'rgba(255,255,255,.1)', borderRadius: 8 }}
      onClick={handleClickOpenStages}
    >
      <div className="d-block">
        <img
          src={stageIconUrl}
          alt="stage"
          className="d-block"
          style={{
            height: openStageIconSize,
            width: openStageIconSize,
            objectFit: 'contain',
            borderRadius: 8,
          }}
        />
      </div>
      <div>
        <div>
          <strong>Open stages</strong>
        </div>
        <div>
          <span>{`${openStageCount} Available`}</span>
        </div>
      </div>
      <div className="ml-auto px-2">
        <FontAwesomeIcon name="chevron-right" />
      </div>
    </div>
  );
};
